import { useNavigate } from "react-router-dom";
import withLoader from "../../../components/layouts/WithLoader";
import { makeAnimated } from "react-select/animated";
import { useEffect, useState } from "react";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import PromoCaisseService from "../../../services/MarketingService/PromoCaisseService";

import { Alert, Snackbar } from "@mui/material";
import DataTableListPromoDetails from "./DataTableListPromoDetails";
import UtilsFormule from "../../../utils/UtilsFormule";

const PromoGroupDetails = ({ startLoading, stopLoading }) => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [listPromoCaisse, setListPromoCaisse] = useState(null);
  const [promoGroup, setPromoGroup] = useState(null);

  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    startLoading();
    PromoCaisseService.getListPromosByGroupe(
      getCurrentUserId(),
      sessionStorage.getItem("idPromoGroup")
    )
      .then((response) => {
        if (response.data.success) {
          setListPromoCaisse(response.data.list);
          setPromoGroup(response.data.success);
          setShowTable(true);
        }
      })
      .catch((e) => {
        console.error("Error fetching gift card details:", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br/>
      <section className="content-header">
      <div className="row">
        <div className="col-md-6 col-sm-12 col-12">
          <div className="info-box bg-gray ">
            <span className="info-box-icon">
              <i class="fas fa-map-marker-alt mr-1"></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">Promo</span>
              <span className="info-box-number">{promoGroup?.title} </span>
              <div className="progress">
                <div className="progress-bar" style={{ width: "70%" }} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-sm-12 col-12">
          <div className="info-box bg-gray-dark ">
            <span className="info-box-icon">
            <i
                className={`fas ${
                  promoGroup?.isActive === 1
                    ? "fa-check-circle"
                    : "fa-times-circle"
                }`}
              ></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">Active</span>
              <span className="info-box-number">
                {/* {warehouseManagers.length} */}
              </span>
              <div className="progress">
                <div className="progress-bar" style={{ width: "70%" }} />
              </div>
              <span className="progress-description">
                {/* {warehouseManagers.length} */}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
      <div className="col-md-12 col-sm-12 col-12">
      <div className="info-box bg-gray ">
            <span className="info-box-icon">
              <i class="fas fa-map-marker-alt mr-1"></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">Période</span>
              <span className="info-box-number">De { UtilsFormule.formatDateHours(promoGroup.dateDebut) } jusqu'à { UtilsFormule.formatDateHours(promoGroup.dateFin)}</span>
              <div className="progress">
                <div className="progress-bar" style={{ width: "70%" }} />
              </div>
            </div>
          </div>
        </div></div>
      </section>

    

      {listPromoCaisse && Array.isArray(listPromoCaisse) && <DataTableListPromoDetails listPromoCaisse={listPromoCaisse} />}

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(PromoGroupDetails);
